import { OnelinkRequestFilters } from "../../../models/Order/OnelinkRequestFilters";
import {
  APIBlobResponse,
  APIResponse,
  PaginatedAPIResponse,
} from "../../../models/NetworkResponse";
import { OnelinkRequest } from "../../../models/Order/OnelinkRequest";
import { getAPI, postAPI } from "../../../api/Networking";

export default class OnelinkRequestAPI {
  getOnelinkRequests = async (
    filters: OnelinkRequestFilters
  ): Promise<PaginatedAPIResponse<OnelinkRequest> | APIBlobResponse> => {
    try {
      const queryParams = new URLSearchParams();

      if (filters.page_no)
        queryParams.append("page_no", filters.page_no.toString());

      if (filters.limit) queryParams.append("limit", filters.limit.toString());

      if (filters.search_text)
        queryParams.append("search_text", filters.search_text.toString());

      if (filters.order_id)
        queryParams.append("order_id", filters.order_id.toString());

      if (filters.customer_id)
        queryParams.append("customer_id", filters.customer_id.toString());

      if (filters.status)
        queryParams.append("status", filters.status.toString());

      if (filters.sort_by)
        queryParams.append("sort_by", filters.sort_by.toString());

      if (filters.sort_type)
        queryParams.append("sort_type", filters.sort_type.toString());

      const response = await getAPI(
        `/v5/orders/onelink-redemption?${queryParams.toString()}`
      );

      return response.result;
    } catch (error) {
      throw error;
    }
  };

  approveOnelinkRequest = async (
    id: number,
    order_id: number
  ): Promise<APIResponse> => {
    try {
      const response = await postAPI(
        `/v5/orders/onelink-redemption/order_id/${order_id}/onelink-request/${id}/action/approve`
      );
      return response;
    } catch (error) {
      throw error;
    }
  };

  rejectOnelinkRequest = async (
    id: number,
    order_id: number
  ): Promise<APIResponse> => {
    try {
      const response = await postAPI(
        `/v5/orders/onelink-redemption/order_id/${order_id}/onelink-request/${id}/action/reject`
      );
      return response;
    } catch (error) {
      throw error;
    }
  };
}
